var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{attrs:{"disabled":_vm.isRecording},on:{"click":_vm.startRecording}},[_vm._v("Start Recording")]),_c('button',{attrs:{"disabled":!_vm.isRecording},on:{"click":_vm.stopRecording}},[_vm._v("Stop Recording")]),_c('button',{attrs:{"disabled":!_vm.recordedAudio},on:{"click":_vm.saveRecording}},[_vm._v("Save Recording")])])
}
var staticRenderFns = []

export { render, staticRenderFns }